/**
 * Converte a rota absoluta de um `NavItem` no path relativo que um `<Routes>` aninhado entende.
 *
 * **Por que isto é preciso.** Os itens de navegação guardam rotas absolutas (`/home/mapa`) porque é
 * o que o `<NavLink>` precisa para navegar. Mas o shell é montado pelo `app-router` em `/home/*`, e
 * um `<Routes>` aninhado resolve os seus paths **contra a base já consumida pelo pai** — ele só vê
 * o que sobra do splat. Um path absoluto ali nunca casa, e a tela renderiza em branco.
 *
 * Foi exatamente o que os testes dos shells apanharam: `page-map` não existia, embora o separador
 * apontasse para `/home/mapa` e a rota parecesse declarada.
 *
 * Derivar em vez de escrever a lista duas vezes mantém `nav-items.ts` como fonte única.
 */
export function rotaRelativa(rotaAbsoluta: string, prefixo: string): string {
  if (rotaAbsoluta === prefixo) {
    // A rota-índice do shell (`/home` dentro de `/home/*`) é o path vazio para o router aninhado.
    // Devolver `/` faria dela uma rota absoluta outra vez — o bug que esta função existe para evitar.
    return '';
  }

  const semPrefixo = rotaAbsoluta.startsWith(`${prefixo}/`)
    ? rotaAbsoluta.slice(prefixo.length + 1)
    : rotaAbsoluta;

  // Nunca devolver algo iniciado por barra: seria interpretado como absoluto pelo `<Route>`.
  return semPrefixo.replace(/^\/+/, '');
}
